module.exports = __webpack_public_path__ + "static/media/striped_bar_M3.99a041e8.svg";